module.exports = __webpack_public_path__ + "static/img/training_system_hy_s5_2.22574b02.png";